import AlYusrAxiosApiInstance from "../axios/alYusrAxiosApiInstance";
import { AlYuserApiUrls } from "../configuration";
import { ResponseBaseModel } from "../models";
import { UploadedFileModel } from "../models/files/fileModel";

export const uploadFilesEntity = async (
  request: any
): Promise<ResponseBaseModel<UploadedFileModel[]>> => {
  return await AlYusrAxiosApiInstance.post(
    AlYuserApiUrls.entityUploadedDocumentController.saveUploadedDocument,
    request
  );
};
export const getUploadedDocumentByEntityId = async (request: {
  entityId: number;
  entityDocumentTypeId: number;
}): Promise<ResponseBaseModel<UploadedFileModel[]>> => {
  let url: string = `${AlYuserApiUrls.entityUploadedDocumentController.GetEntityUploadedDocumentByTypeId}?entityDocumentTypeId=${request.entityDocumentTypeId}&entityId=${request.entityId}`;

  return await AlYusrAxiosApiInstance.get(url);
};
